import styled from 'styled-components';
import { Grid, Box, Button, Card, Typography } from '@mui/material';
import { saasModernTheme } from 'common/theme/saasModern';

export const StyledGridContainer = styled(Grid)`
  border-radius: 20px;
  background-color: var(--Background-Default, #fff);
  margin: 115px 0;
  padding: 50px;
  display: flex;
  align-items: center;

  &:hover {
    box-shadow: ${saasModernTheme.gradiantShadow};
  }
`;

export const StyledTitleBox = styled(Typography)`
  color: var(--Text-Primary, #111927);
  font-size: 36px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  & strong {
    background: ${saasModernTheme.customColor.backgroundTextGradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  @media screen and(max-width: 950px) {
    font-size: 30px;
  }
  @media screen and (max-width: 600px) {
    font-size: 24px;
  }
`;

export const StyledDescriptionBox = styled(Box)`
  color: var(--Text-Secondary, #636f81);
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`;

export const StyledButtonPrimary = styled(Button)`
  color: var(--White-White, #fff);
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  letter-spacing: -0.28px;
  background-color: #ff5a5f;
  margin-bottom: 10px;
  border-radius: 12px;
  padding: 12px 16px;
  text-transform: none;
  height: 40px;
  &:hover {
    box-shadow: ${saasModernTheme.gradiantShadow};
    background: ${saasModernTheme.customColor.gradiantColor};
  }
  @media (max-width: 600px) {
    font-size: 12px;
    padding: 6px 10px;
    margin-bottom: 0;
  }
`;

export const StyledButtonSecondary = styled(Button)`
  color: var(--Text-Primary, #111927);
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  margin-bottom: 10px;
  background-color: transparent;
  border: 1px solid var(--Outlined-Outlined, rgba(145, 155, 171, 0.24));
  border-radius: 12px;
  padding: 12px 16px;
  height: 40px;
  text-transform: none;
  @media (max-width: 600px) {
    font-size: 12px;
    padding: 6px 10px;
    margin-bottom: 0;
  }
  &:hover {
    box-shadow: ${saasModernTheme.gradiantShadow};
    border: 1px solid #d1d5db;
  }
`;

export const StyledCard = styled(Card)`
  background-color: black;
  border-radius: 20px;
  position: relative;
  width: 100%;
  height: auto;
  @media screen and(max-width: 950px) {
    font-size: 30px;
  }
  @media screen and (max-width: 600px) {
    font-size: 24px;
    margin-top: 16px;
  }
`;
